const ad = window.addiesaas || {}
const adConfig = ad.config || {}
const bookingsConfig = ad['raceway-booking'] || {}
const supercharged = ad['supercharged'] || {}
const clubspeed = ad['clubspeed'] || {}
const products = ad['products'] || {}
const routes = _.keyBy(ad['routes'] || [], 'name')

export const config = Object.assign({}, bookingsConfig, {
  supercharged,
  products,
  clubspeed,
  routes,
  RE: ad,
  CONFIG: adConfig,
})
console.log(ad.connected);
if (!ad.connected) {
  console.error('Unable to connect to Clubspeed API!');
}
export default config

